/** Safe embedding of JSON-LD inside HTML <script> (avoids broken DOM / empty script bodies with React + Helmet). */
export function serializeJsonLdForHtmlScript(data: unknown): string {
  return JSON.stringify(data).replace(/</g, "\\u003c");
}
